import { QcStatusOption } from './types';

const SECTION_SEPARATION_QC_OPTIONS: QcStatusOption[] = [
  { label: 'Section Separation Not QCed', value: 'section separation not qced' },
  { label: 'Section Page Mapping Not QCed', value: 'section page mapping not qced' },
  { label: 'Original Page Mapping Not QCed', value: 'original page mapping not qced' },
  { label: 'Escalated', value: 'escalated' }
];

export default SECTION_SEPARATION_QC_OPTIONS;
